import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import siteConfig from '../config/siteContent';

const Footer = () => {
  return (
    <footer className="bg-[#2B2B2B] text-white">
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_6400c586-49b7-4f08-ac06-403ab984ab21/artifacts/iqu8vwey_Repose%20golden.png" 
                alt="Repose Hotels Logo" 
                className="h-12 w-12"
              />
              <div>
                <h3 className="font-playfair text-xl font-bold tracking-wider">REPOSE HOTELS</h3>
                <p className="text-xs tracking-widest text-[#B89C4A]">HOSPITALITY GROUP</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Strategic Hotel Asset Partners driving performance through discipline and proven leadership.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6 text-[#B89C4A]">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">Our Services</Link></li>
              <li><Link to="/case-studies" className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">Case Studies</Link></li>
              <li><Link to="/investors" className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">For Investors</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6 text-[#B89C4A]">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Hotel Acquisition Advisory</li>
              <li className="text-gray-400">Asset Management</li>
              <li className="text-gray-400">Franchise Operations</li>
              <li className="text-gray-400">Business Development</li>
              <li className="text-gray-400">Financial Performance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-6 text-[#B89C4A]">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#B89C4A] flex-shrink-0 mt-1" />
                <span className="text-gray-400">{siteConfig.contact.location.city}, {siteConfig.contact.location.state}<br />{siteConfig.contact.location.country}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#B89C4A] flex-shrink-0 mt-1" />
                <a href={`mailto:${siteConfig.contact.email}`} className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">
                  {siteConfig.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#B89C4A] flex-shrink-0 mt-1" />
                <a href={`tel:${siteConfig.contact.phone}`} className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300">
                  {siteConfig.contact.phoneDisplay}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Repose Hotels Pty Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="#" 
                className="text-gray-400 hover:text-[#B89C4A] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
